import { render, staticRenderFns } from "./AggAreaIndustry.vue?vue&type=template&id=df86eb6a&"
import script from "./AggAreaIndustry.vue?vue&type=script&lang=js&"
export * from "./AggAreaIndustry.vue?vue&type=script&lang=js&"
import style0 from "./AggAreaIndustry.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QTable from 'quasar/src/components/table/QTable.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTable,QMenu,QCard,QList,QItem});
